import { createSlice } from "@reduxjs/toolkit";
import {
  getCountry,
} from "./countryService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  countryList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Country List ---------- */
    builder
      .addCase(getCountry.pending, (state) => {
        state.countryList.status = STATUS.LOADING;
        state.countryList.error = null;
      })
      .addCase(getCountry.fulfilled, (state, action) => {
        state.countryList.status = STATUS.SUCCEEDED;
        state.countryList.data = action?.payload?.data || [];
      })
      .addCase(getCountry.rejected, (state, action) => {
        state.countryList.status = STATUS.FAILED;
        state.countryList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectCountryList = (state) =>
  state.country.countryList;

export default countrySlice.reducer;
